import { socials } from '../consts';
import { SocialId } from '../types';

export const filterSocials = (idFilter?: SocialId[]) => (!idFilter
  ? socials
  : idFilter.map((socialId) => socials.find((s) => s.id === socialId)));
